export default "__VITE_ASSET__DWWGUBB0__"